import * as React from 'react';

/**
 * Pending SVG component
 *
 * @returns
 */
function ExclamationTriangleSVG(svgProps: SVGProps) {
	return (
		<svg
			viewBox="0 0 34 32"
			className={'icon icon-exclamation-triangle ' + svgProps.class}
			focusable="false"
			aria-hidden="true"
		>
			<path d="M33.879 27.321l-14.123-25.762c-0.499-0.934-1.468-1.559-2.583-1.559s-2.084 0.625-2.575 1.544l-0.008 0.016-14.181 25.762c-0.265 0.449-0.422 0.989-0.422 1.565 0 1.682 1.332 3.052 2.999 3.113l0.006 0h28.304c1.672-0.061 3.005-1.432 3.005-3.113 0-0.577-0.157-1.117-0.43-1.58l0.008 0.015zM15.522 10.864c-0.004-0.040-0.006-0.088-0.006-0.135 0-0.884 0.716-1.6 1.6-1.6s1.6 0.716 1.6 1.6c0 0.048-0.002 0.095-0.006 0.141l0-0.006v7.851c0.004 0.040 0.006 0.088 0.006 0.135 0 0.884-0.716 1.6-1.6 1.6s-1.6-0.716-1.6-1.6c0-0.048 0.002-0.095 0.006-0.141l-0 0.006zM17.17 27.2c-0.023 0.001-0.050 0.002-0.078 0.002-0.927 0-1.678-0.751-1.678-1.678s0.751-1.678 1.678-1.678c0.927 0 1.678 0.751 1.678 1.678 0 0 0 0 0 0v-0c0 0.012 0 0.025 0 0.039 0 0.891-0.712 1.616-1.599 1.636l-0.002 0z" />
		</svg>
	);
}

ExclamationTriangleSVG.defaultProps = { class: '' };

export default ExclamationTriangleSVG;
